import React from 'react';
import { MediaQueryConstants, ViewportSize } from "../common";
const DEFAULT_VIEWPORT_SIZE = ViewportSize.LARGE;
const DEFAULT_IS_VIEWPORT_COMPACT = false;
/**
 * Hooks that provides the viewport size information
 * @returns {IViewportSize} IViewportSize with viewport size, and isCompact information.
 * The isCompact property is ture when viewport size is medium or small or extra small.
 */
export const useViewportSize = () => {
    const [viewportSize, setViewportSize] = React.useState({
        size: DEFAULT_VIEWPORT_SIZE,
        isCompact: DEFAULT_IS_VIEWPORT_COMPACT
    });
    const handleResize = () => {
        const viewSize = getViewportSize();
        if (viewSize.size !== viewportSize.size) {
            setViewportSize(viewSize);
        }
    };
    React.useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    });
    return viewportSize;
};
const isMatchingQuery = (query) => window.matchMedia(query).matches;
const getViewportSize = () => {
    let size = DEFAULT_VIEWPORT_SIZE;
    let isCompact = DEFAULT_IS_VIEWPORT_COMPACT;
    if (isMatchingQuery(MediaQueryConstants.EXTRA_LARGE)) {
        size = ViewportSize.EXTRA_LARGE;
    }
    else if (isMatchingQuery(MediaQueryConstants.LARGE)) {
        size = ViewportSize.LARGE;
    }
    else if (isMatchingQuery(MediaQueryConstants.MEDIUM)) {
        size = ViewportSize.MEDIUM;
        isCompact = true;
    }
    else if (isMatchingQuery(MediaQueryConstants.SMALL)) {
        size = ViewportSize.SMALL;
        isCompact = true;
    }
    else if (isMatchingQuery(MediaQueryConstants.EXTRA_SMALL)) {
        size = ViewportSize.EXTRA_SMALL;
        isCompact = true;
    }
    return {
        isCompact,
        size
    };
};
//# sourceMappingURL=useViewportSize.js.map